import MessageFormatter from 'shared/helpers/MessageFormatter';

// Chat text → safe HTML (markdown, links), with "#123" turned into links to the conversations the server previewed and
// mentioned people in bold. Render with v-dompurify-html.
export const formatChatMessage = (message, { accountId, people = [] }) => {
  let text = message.content || '';

  (message.content_attributes?.links || []).forEach(link => {
    const reference = new RegExp(`(^|[^\\w&\\[])#${link.id}\\b`, 'g');
    text = text.replace(
      reference,
      `$1[#${link.id}](/app/accounts/${accountId}/conversations/${link.id})`
    );
  });

  (message.content_attributes?.mentions || []).forEach(id => {
    const person = people.find(item => item.id === id);
    if (person)
      text = text.replaceAll(`@${person.name}`, `**@${person.name}**`);
  });

  return new MessageFormatter(text).formattedMessage;
};

export const dayKey = timestamp => new Date(timestamp * 1000).toDateString();

export const dayLabel = (timestamp, t, locale) => {
  const date = new Date(timestamp * 1000);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  if (date.toDateString() === today.toDateString()) return t('LOCO.CHAT.TODAY');
  if (date.toDateString() === yesterday.toDateString())
    return t('LOCO.CHAT.YESTERDAY');
  return date.toLocaleDateString(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
};

export const timeLabel = (timestamp, locale) =>
  new Date(timestamp * 1000).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });

// Consecutive messages from the same person within 5 minutes are shown without repeating the name
export const groupsWithPrevious = (message, previous) =>
  Boolean(
    previous &&
      previous.sender?.id === message.sender?.id &&
      dayKey(previous.created_at) === dayKey(message.created_at) &&
      message.created_at - previous.created_at < 300
  );
